module.exports = __webpack_public_path__ + "media/assets/images/rain_later_will_snow-9003e11db0b66f5333fe07474c4a54b9.png";